module.exports = __webpack_public_path__ + "static/media/red.fdc32aa2.JPG";